import {camelizeKeys} from 'humps';
import LocalStorageWrapper from "../../localStorageWrapper";
import httpRequestMethods from "../../httpRequestMethods";
import HttpStatusCodes from "../../httpStatusCodes";

export const ROOFSNAP_API_BASE_URL = `${process.env.REACT_APP_API_HOST}`;
let baseUrl = '';

function buildApiConfigRequest(method, body, version) {
    const config = {};
    config.method = method;
    config.headers = {
        'X-Api-Key': `${process.env.REACT_APP_API_KEY}`,
        'Content-Type': 'application/json',
        RSClient: 'ShadyShark'
    };

    const token = LocalStorageWrapper.getItem('accessToken');
    config.headers.Authorization = `Bearer ${token}`;

    if (version) {
        config.headers['If-Match'] = `"${version}"`;
    }

    if (body) {
        config.body = JSON.stringify(body);
    }

    return config;
}

async function handleApiErrors(response) {
    switch (response.status) {
        case HttpStatusCodes.Unauthorized: {
            // Clear everything, including the roofsnap access token, out of local storage
            LocalStorageWrapper.clear();
            window.location.pathname = '/login';
            return Promise.reject(response);
        }
        default:
            return Promise.reject(response);
    }
}

async function callApi(url, config) {
    const response = await fetch(url, config);
    if (!response.ok) {
        await handleApiErrors(response);
        return;
    }
    if(response.status == 204){
        return {success: true};
    }
    const json = await response.json();

    return camelizeKeys(json);
}

class RoofSnapApiClient {
    constructor(version) {
        baseUrl = '';
        baseUrl = `${ROOFSNAP_API_BASE_URL}${version}/`;
    }

    async get(endpoint) {
        const url = `${baseUrl}${endpoint}`;

        const config = buildApiConfigRequest(httpRequestMethods.GET);
        return await callApi(url, config);
    }

    async update(endpoint, body, version) {
        const url = `${baseUrl}${endpoint}`;

        const config = buildApiConfigRequest(httpRequestMethods.PUT, body, version);
        return await callApi(url, config);
    }

    async create(endpoint, body) {
        const url = `${baseUrl}${endpoint}`;

        const config = buildApiConfigRequest(httpRequestMethods.POST, body);
        return await callApi(url, config);
    }

    async delete(endpoint) {
        const url = `${baseUrl}${endpoint}`;

        const config = buildApiConfigRequest(httpRequestMethods.DELETE);
        return await callApi(url, config);
    }
}

export default RoofSnapApiClient;
